import * as yup from 'yup';

export const Schema = yup.object({
  artistSpotifyId: yup.string().nullable().required('Field is required'),
});
